import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './list.css'
import Slider from "react-slick";
import {userList} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import {authenticationFn} from '../../redux/chatuser.redux.js'

import {getElementPosition} from '../../util.js'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {getGiftSuccessCallBack} from  '../../redux/chatuser.redux.js'
import ToastBar from '../../component/toast/toast.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,getGiftSuccessCallBack}
)

class ReturnList extends React.Component{
	constructor(props){
		super(props)
		this.state={
			  GetPacks:'',
			  getCates:'',
			  zoneNum:0,
			  navNum:0,
			  showSelectWelfare:false,
		      visible:false,
		      showGetSuccess:false,
		      iTop:'',		     
		      giftData:'',
		      key:1,
		      inum:0,
		      packId:'',
		      showWrongAlert:false,
		      zoneArr:[],
			  roleArr:[],
			  ifRole:false,
			  ifRoleNum:0,
			  ifZone:true,
			  myCateId:'',
			  myCateNum:0
		   
    	}
    	this.game_id = this.props.match.params.id	
    	this.handleLogin = this.handleLogin.bind(this)
    	this.showAlert = this.showAlert.bind(this)
    	this.showWrongAlert = this.showWrongAlert.bind(this)
    	this.ToastBarClose = this.ToastBarClose.bind(this)
    	this.onOff = true
    	this.myAccountData=''
	}
	componentDidMount(){
		document.title = '心享俱乐部—永恒之塔回归特权'
  		if(this.props.inum==='1'){
  			this.handleGetCates('1')
  		}
  		if(this.props.inum==='2'){
  			this.handleGetCates('4')
  		}

  	}
	componentWillReceiveProps(nextProps){
		
		if(this.props.getGiftSuccessData!==nextProps.getGiftSuccessData){
			if(nextProps.getGiftSuccessData==='1'){
				
		 		this.state.getCates[this.state.navNum]&&this.handleGetPacks(this.state.getCates[this.state.navNum].id)
		 		this.setState({
		 			myCateNum:0
		 		})
		 		
		 		//var oHref = window.location.href 
		 		//window.location.href = oHref
		 	}
		}
	
  		 if (this.props.accountData.account!== nextProps.accountData.account||nextProps.ikey){
  		 	
  		 	this.myAccountData = nextProps.accountData
  		 	
			if(nextProps.accountData.grade&&this.props.inum==='1'){
				
				const oGrade = nextProps.accountData.grade
				
				var num =''
				if(oGrade>=8){
				num = 2
				}
				if(oGrade>4&&oGrade<=7){
				num = 1
				}
				if(oGrade<=4){
				num = 0
				}
				this.setState({
					navNum:num					
				})
				if(nextProps.ikey){
					this.handleGetCates('1')
					return
				}

		  		this.state.getCates[num]&&this.handleGetPacks(this.state.getCates[num].id,nextProps.accountData)
		  				  		
	  		}
	  		if(!nextProps.accountData.grade){
	  			this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id,nextProps.accountData)
	  			this.setState({
					navNum:0
				})
	  		}
	  		if(this.props.inum==='2'){
	  			
				
	  			if(parseFloat(nextProps.iMoney)||parseFloat(nextProps.iMoney)==0){
	  				/*
		  			if(parseFloat(nextProps.iMoney)<1000){
		  				this.setState({
							navNum:0					
						})			
				  		this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
		  			}else if(parseFloat(nextProps.iMoney)>1000&&parseFloat(nextProps.iMoney)<5000){
		  				
		  				this.setState({
							navNum:1					
						})	
						this.state.getCates[1]&&this.handleGetPacks(this.state.getCates[1].id)
		  			}else if(parseFloat(nextProps.iMoney)>5000){
		  				this.setState({
							navNum:2					
						})	
						
						this.state.getCates[2]&&this.handleGetPacks(this.state.getCates[2].id)
		  			}
		  			*/
	  			}else{
	  				this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
	  			}
	  		}
	  		
  	
  		 }

  	}
  	handleGetCates(num){
  		
  		axios.get('/fapi/recom/getCates?gameid='+this.game_id+'&type='+num)
    		.then(res=>{
    			if(res.data.return_code===0){
    				this.setState({
    					getCates:res.data.data
    				})
    				res.data.data.length&&this.handleGetPacks(res.data.data[this.state.navNum].id)
    			}
    			
    			
    		})

  	}
  	handleGetPacks(_id,accountData){
  		var acData = ''
  		if(this.myAccountData.t_account){  			
  				acData = this.myAccountData.t_account

  		}
  		axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+_id+'&account='+acData)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
					 function unique(arr,attribute){
				        var new_arr=[];
				        var json_arr=[];
				        for(var i=0; i<arr.length; i++){
				            
				            if(new_arr.indexOf(arr[i][attribute]) ==-1){    //  -1代表没有找到
				                new_arr.push(arr[i][attribute]);   //如果没有找到就把这个name放到arr里面，以便下次循环时用
				                json_arr.push(arr[i]);
				            } else{
				            }
				        }
				        return json_arr;
				    }
				   
					if(this.props.inum=='1'){
						var iZone = []
						var iRole=[]
						iZone = unique(res.data.data,'sub_cate_name')

						if(this.state.navNum===0){
							
  							this.setState({
								zoneArr:iZone,
								roleArr:[],
								ifRole:false,
								ifRoleNum:97,
								myCateId:_id,
								GetPacks:[res.data.data[0]],
								myCateNum:this.state.myCateNum+1

								
							})
  						}else if(this.state.navNum===1){
							
							for(let i=0;i<res.data.data.length;i++){
								if(res.data.data[i].sub_cate_name=='8.0版本区'){
									iRole.push(res.data.data[i]) 
								}
							}
							this.setState({
								zoneArr:iZone,
								roleArr:iRole,
								ifRole:true,
								ifRoleNum:98,
								myCateId:_id,
								myCateNum:this.state.myCateNum+1,
								GetPacks:[res.data.data[0]]
							
							})
							
  							
  						}else if(this.state.navNum===2){
							
							for(let i=0;i<res.data.data.length;i++){
								if(res.data.data[i].sub_cate_name=='5.8版本区'){
									iRole.push(res.data.data[i]) 
								}
							}
							this.setState({
								zoneArr:iZone,
								roleArr:iRole,
								ifRole:false,
								ifRoleNum:99,
								myCateId:_id,
								myCateNum:this.state.myCateNum+1,
								GetPacks:[res.data.data[0]]
							
							})
  						}
					}else{
						
						var iZone = []
						var iRole=[]
						var iZone =  unique(res.data.data,'sub_cate_name')
						var onOff = true
						if(this.state.navNum===0){
							onOff = false
						}
						this.setState({
							zoneArr:iZone,
							roleArr:[],
							ifRole:false,
							ifZone:onOff,
							ifRoleNum:100,
							myCateId:_id,
							myCateNum:this.state.myCateNum+1,
							GetPacks:[res.data.data[0]]

								
						})
					}
					
  					
					//var idata = unique(res.data.data,'sub_cate_name')
					/*
					this.setState({
						GetPacks:res.data.data
						
					})
					*/
					this.props.getGiftSuccessCallBack('0')
  				}
  				 				 				
  			})
  	} 
  	handleZone(e,num){
  		var acData = ''
  		var iVal = e?e.target.options[e.target.options.selectedIndex].value:''
  		if(this.myAccountData.t_account){  			
  				acData = this.myAccountData.t_account

  		}
  		axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+this.state.myCateId+'&account='+acData)
  			.then(res=>{
  				
  				if(res.data.return_code===0){

					
					if(this.state.ifRoleNum===97||this.props.inum==='2'){
						
						if(iVal==='8.0版本区'){
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[0]]
							})
						}else{
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[1]]
							})
						}
						
					}
					else if(this.state.ifRoleNum===98){

						if(iVal==='8.0版本区'){
							this.setState({
								ifRole:true,
								GetPacks:[res.data.data[0]]
							})

						}else{
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[res.data.data.length-1]]
							})
						}
						
					}else if(this.state.ifRoleNum===99){
						if(iVal==='5.8版本区'){
							this.setState({
								ifRole:true,
								GetPacks:[res.data.data[1]]
							})
						}else{
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[0]]
							})
						}
						
					}else{
						if(iVal==='8.0版本区'){
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[0]]
							})
						}else{
							this.setState({
								ifRole:false,
								GetPacks:[res.data.data[1]]
							})
						}
						
					}
  				}
  			})
		
  	}
  	handleServe(e){
  		var acData = ''
  		var iIndex = e.target.options.selectedIndex
  		
  		if(this.myAccountData.t_account){  			
  				acData = this.myAccountData.t_account

  		}
  		axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+this.state.myCateId+'&account='+acData)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
						
					
					if(this.state.ifRoleNum==98){
						
							this.setState({
							
								GetPacks:[this.state.roleArr[iIndex]]
							})

					
						
					}else if(this.state.ifRoleNum===99){
						this.setState({
						
							GetPacks:[this.state.roleArr[iIndex]]
						})
					}
  				}
  			})
  	}
  	handleNav(i,_id){
		this.setState({
			navNum:i
		})
		this.handleGetPacks(_id)
  	}
  	
  
  	handleLogin(){		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
			
	}
	showWrongAlert(e){
		this.setState({
	  		showWrongAlert:true
	  			
	  	})
	  	this.iTop = getElementPosition(e.target).y+'px'
	}
  	getGiftBtnFn(){
		
  		if(this.props.userlist.code===-1){
  			var str = '立即领取'
  			var icls = 'getBtn1'
  			var callBack = this.handleLogin
  			
  			if(this.props.inum==2&&this.state.navNum===0){
  				str = '1元购买'
  			}
  			if(this.props.authentication==1||this.props.authentication==''){
				
				return <button className="getBtn1" onClick={()=>this.handleLogin()}>{str}</button>
  			}
  			if(this.props.authentication==3){
				
				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
					
  					str = '立即领取'
  					
  					if(this.props.inum==2&&this.state.navNum===0){
  						
		  			 str = '1元购买'
		  			}
  				}
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
	  				 str = '待解锁'
	  				 icls = 'getBtn2'
	  				 callBack = function () { }
	  				 	
	  				
	  			}
	  			if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
	  				 str = '已领取'
	  				  icls = 'getBtn2'
	  				  callBack = function () { }
	  			}
  				return <button className={icls} onClick={()=>callBack()}>{str}</button>
  			
				
  			}
  			if(this.props.authentication==2){
  				
  				return <button className="getBtn2" >待解锁</button>
  			}
  			
  		}else{
  			var str = ''
  			var icls = 'getBtn1'
  			var callBack = this.showAlert
  			if(this.props.authentication==3){
  			
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
					
  					str = '立即领取'
  					
  					if(this.props.inum==2&&this.state.navNum===0){
  						
		  			 str = '1元购买'
		  			}
		  			if(this.state.GetPacks[0].alert){
		  				callBack=this.showWrongAlert
		  			}
  				}
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
	  				 str = '待解锁'
	  				 icls = 'getBtn2'
	  				 callBack = function () { }
	  			}
	  			if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
	  				 str = '已领取'
	  				  icls = 'getBtn2'
	  				 callBack = function () { }
	  			}
  				return <button className={icls} onClick={(e)=>callBack(e)}>{str}</button>
  			}
  			if(this.props.authentication==2){
  				
  				return <button className="getBtn2" >待解锁</button>
  			}
  			
  		}
  		
  	}
  	showAlert(e){
  		var idata = this.state.GetPacks[this.state.zoneNum].good_id
  		this.setState({
  			showSelectWelfare:true,
  			visible:false,
  			showGetSuccess:false,
  			iTop:getElementPosition(e.target).y+'px',
  			giftData:{id:idata},
  			key:this.state.key+1,
  			packId:this.state.GetPacks[this.state.zoneNum].id
  		})
  	}
  	afterChangeFn(i){
		this.setState({
			zoneNum:i
		})
  	}
  	handleStyle(e){
  		return {
			color:'red'
  		}
  	}
  	ToastBarClose(data){
  		
  		this.setState({
	  		showWrongAlert:false,
	  			
	  	})
  	}
  	render(){

  		const {navData} = this.props
		
	
  		return (

				<div className="return-list" id="return-list-78">
					<nav className={this.props.inum==='2'?'xiaohao-list':''}>
						{this.state.getCates&&this.state.getCates.map((item,i)=>{
							return (<div key={i} className={i===this.state.navNum?'active':''}>
										<span onClick={()=>this.handleNav(i,item.id)}>{item.name}</span>
										<i></i>										
									</div>)
						})}
												
					</nav>
					
			     	<div className="zone-list-name">
			     		<div className="zone-list" style={this.state.ifZone?{display:'inline-block'}:{display:'none'}}>
			     			<select name="" id="" key={this.state.myCateNum} onChange={(e)=>this.handleZone(e)}>

								{
									this.state.zoneArr&&this.state.zoneArr.map((item,i)=>(
									
										<option key={i} value={item.sub_cate_name}>{item.sub_cate_name}</option>
									
									))


								}
			     			</select>
			     			{
			     				this.state.ifRole&&<select name="" id="" onChange={(e)=>this.handleServe(e)} key={this.state.ifRoleNum+4}>

									{
										this.state.roleArr&&this.state.roleArr.map((item,i)=>(
										
											<option key={i} value="">{item.classname}</option>
										
										))


									}
			     				</select>
			     			}
							{
								/*
								this.state.GetPacks&&this.state.GetPacks.map((item,i)=>(
									<select name="" id="">
										<option value="">{item.sub_cate_name}</option>
										
									</select>
									
								))*/
							}
						</div>
					</div>
					<Slider 						
						
				        swipeToSlide={true}
         				focusOnSelect={false}
         				slidesToScroll={1}						
						infinite={false}
						arrows={false}
						afterChange={(i)=>this.afterChangeFn(i)}
						 className="return-gift-box2"
						
				     >
						{this.state.GetPacks&&this.state.GetPacks.map((item,i)=>(
							<div key={i}>
									
										<ul className="return-gift-list">
										{
											item.images.map((item,i)=>(
											
												<li  key={i}>
													<div className="return-list-box" style={{backgroundImage:'url('+item.imgurl+')'}}></div>
													<em>{item.title}</em>
												</li>
											
											))
										}
										</ul>
									
								</div>
								
							))}
						
					</Slider>
					{this.getGiftBtnFn()}
					<GiftAlert 
						key={this.state.key}
						showSelectWelfare={this.state.showSelectWelfare}
						visible={this.state.visible}
						showGetSuccess={this.state.showGetSuccess}
						iTop={this.state.iTop}
						giftData={this.state.giftData||''}
						packId={this.state.packId}
					></GiftAlert>
					{
						this.state.showWrongAlert&&<ToastBar 
							visible={this.state.showWrongAlert}
							title={'错误提示'}  
							isOkShow ={false} 
							iTop={this.iTop}
							itype={1}
							ToastBarClose={this.ToastBarClose}
							
						>
						<div className="return-wrong-alert">抱歉，您在5月1日前回归登录永恒之塔，不能领取回归礼包</div>
					</ToastBar>
					}
				</div>
  		)
  	}
}

export default ReturnList




// WEBPACK FOOTER //
// ./src/component/return-pre-list/list78.js